/* eslint-disable prettier/prettier */
export enum Urls {
  HomePage = '/',
  PatientsPage = '/patients',
  ConsultationsPage = '/consultations',
  IndividualConsultationPage = '/consultations/:id',
  ConsultationsByPatient = '/consultations/consultationsByPatient/:id',
  TransactionsPage = '/transactions',
  IndividualTransactionPage = '/transactions/:id',
  EventsPage = '/events',
  ReportsPage = '/reports',
  SettingsPage = '/settings/*',
  HealthCheck = '/healthcheck',
  LoginPage = '/login',
  TwoFactor = '/two-factor',
  ForgotPassword = '/forgot-password',
  SignUpAffiliateAdminPage = '/register',
  PasswordReset = '/password-reset',
  IndividualPage = '/patients/:id',
  OrdersPage = '/orders',
  IndividualOrderPage = '/orders/:id',
  LabOrdersPage = '/lab-orders',
  IndividualLabOrderPage = '/lab-orders/:id',
  LabOrderResultsPage = '/lab-orders-results/:id',
  Messages = '/messages',
  JourneyTemplatePage = '/journey-template',
  IndividualJourneyTemplatePage = '/journey-template/:slug',
  ProductsPage = '/products',
  IndividualProductPage = '/products/:id',
  SubscriptionsPage = '/subscriptions',
  AddSubscriptionPage = '/subscriptions/new',
  EditSubscriptionPage = '/subscriptions/:id/edit',
  IndividualSubscriptionPage = '/subscriptions/:id',
  EcommerceOrdersPage = '/ecommerce-orders',
  AddEcommerceOrderPage = '/ecommerce-orders/new',
  EditEcommerceOrderPage = '/ecommerce-orders/:id/edit',
  IndividualEcommerceOrderPage = '/ecommerce-orders/:id',
  CouponsPage = '/coupons',
  IndividualCouponPage = '/coupons/:id'
}

export enum SettingsUrls {
  PaymentMethod = '/payment-method',
  Details = '/details',
  UserManagement = '/user-management',
  Projects = '/projects',
  Communications = '/communications',
  ProductList = '/product-list',
  TagManagement = '/tag-management',
  PaymentProcessor = '/payment-processor',
  Credentials = '/ctrl-credentials'
}
